export default "__VITE_ASSET__DbuAhUPA__"